export default {
    each: require('lodash.foreach'),
    isEmpty: require('lodash.isempty'),
    snakeCase: require('lodash.snakecase'),
}
